module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Sumvitg-c978db39f3a0a766074081d4c1a12778.png";